module.exports = __webpack_public_path__ + "img/black.c0912e60.gif";